import { FiX } from "react-icons/fi";
import { cn } from "@/shared/lib";

export interface FormClearButtonProps {
  readonly ariaLabel: string;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly onClick: () => void;
}

export function FormClearButton({
  ariaLabel,
  className,
  disabled = false,
  onClick,
}: FormClearButtonProps): React.ReactElement {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={cn(
        "form-clear-button inline-flex h-8 w-8 min-h-8 min-w-8 shrink-0 items-center justify-center rounded-full",
        "bg-destructive text-destructive-foreground shadow-md",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <FiX aria-hidden="true" className="h-4 w-4" />
    </button>
  );
}

FormClearButton.displayName = "FormClearButton";
